






























































































































































import Vue from 'vue';
import UserTools from '@/tools/user';
import MobileLinksPopup from '@/components/ui/MobileLinksPopup.vue';

import firebase from 'firebase/app';
import 'firebase/functions';

export default Vue.extend({
  components: {
    'mobile-links-popup': MobileLinksPopup,
  },
  props: {
    usernameMode: Boolean,
  },
  data() {
    return {
      deleteDialog: false,
      username: '',
      usernameWithError: '',
      usernameInEdit: false,
      usernameLoading: false,
      realName: '',
      realNameError: '',
      realNameInEdit: false,
    };
  },
  computed: {
    deletionPossible(): boolean {
      if (this.usernameMode) {
        return false;
      }
      if (!this.$store.state.user) {
        return false;
      }
      if (this.$store.state.user.isAnonymous) {
        return false;
      }
      return true;
    },
    usernameSaveDisabled(): boolean {
      return this.username === this.$store.state.user.username || this.username.length < 2;
    },
    realNameSaveDisabled(): boolean {
      return this.realName === this.$store.state.user.realName
        || this.realName.length < 2 || this.realNameError !== '';
    },
    usernameError(): boolean {
      return this.usernameWithError.length > 0 && this.usernameWithError === this.username;
    },
  },
  methods: {
    async onDelete(): Promise<void> {
      if (this.deletionPossible) {
        await UserTools.deleteAccount(this.$store, this.$router);
      }
    },
    onCancelUsername(): void {
      this.usernameWithError = '';
      this.usernameInEdit = false;
    },
    onEditUsername(): void {
      this.username = this.$store.state.user.username;
      this.usernameInEdit = true;
    },
    async onSaveUsername(): Promise<void> {
      this.usernameLoading = true;
      this.usernameWithError = '';
      const data = await (firebase.functions().httpsCallable('createUsername')({
        username: this.username,
      }));
      this.usernameLoading = false;
      if (data.data.status === 'success') {
        this.$store.commit('setUser', {
          ...this.$store.state.user,
          username: this.username.toLowerCase(),
        });
        this.usernameInEdit = false;
      } else {
        this.usernameWithError = this.username;
      }
    },
    onEditRealName(): void {
      this.realName = this.$store.state.user.realName;
      this.realNameInEdit = true;
    },
    onRealNameChange(): void {
      this.realNameError = '';
    },
    validateRealName(): void {
      const nameRegex = /^[a-zA-Z]+ [a-zA-Z]+$/;
      if (!nameRegex.test(this.realName)) {
        this.realNameError = this.$store.state.tr.RealNameValidation;
      } else {
        this.realNameError = '';
      }
    },
    onSaveRealName(): void {
      this.realNameError = '';
      this.validateRealName();
      if (this.realNameError === '') {
        UserTools.saveRealName(this.$store, this.realName);
        this.realNameInEdit = false;
      }
    },
  },
});
